import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {LigneParametrageFacturation} from "../../../../core/models/facturation/client/ligne-parametrage-facturation";
import {FacturationClientService} from "../../../../core/services/entities/facturation-client.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {GraphQLService} from "../../../../core/services/technique/graphql.service";
import {ElementFacturableDTO} from "../../../../core/dtos/ElementFacturableDTO";
import {TaxeDTO} from "../../../../core/dtos/taxe-dto";
import {LigneParametrageFacturationChanges} from "../../../../core/models/facturation/client/ligne-parametrage-facturation-changes";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {applyTauxOrPrixToPeriodeList} from "../../../../core/models/facturation/client/periode-parametrage-facturation";
import {TypePeriodeFacturationEnum} from "../../../../core/enums/facturation/client/type-periode-facturation-enum";
import {FamilleFacturationDto} from "../../../../core/dtos/facturation/clients/famille-facturation/famille-facturation-dto";
import {LigneParametrageFamilleFacturationDataGridComponent} from "../ligne-parametrage-famille-facturation-data-grid/ligne-parametrage-famille-facturation-data-grid.component";
import LigneParametrageFactureClientFilterDto from "../../../../core/dtos/facturation/clients/factures/ligne-parametrage-facture-client-filter-dto";
import {TypeFactureClientEnum} from "../../../../core/enums/facturation/client/type-facture-client-enum";
import {FamilleFacturationService} from "../../../../core/services/entities/famille-facturation.service";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
  selector: 'yo-facturation-client-famille-facturation-parametrage',
  templateUrl: './facturation-client-famille-facturation-parametrage.component.html',
  styleUrls: ['./facturation-client-famille-facturation-parametrage.component.scss'],
  standalone: false
})
export class FacturationClientFamilleFacturationParametrageComponent implements OnInit, OnDestroy {

  subData: Subscription;
  subElementFacturable: Subscription;
  subTaxe: Subscription;
  subSave: Subscription;
  subToAdd: Subscription;
  subFamillesFacturation: Subscription;

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  public readonly TypeFactureClientEnum = TypeFactureClientEnum;

  // region Propriétés grille de paramétrage

  @ViewChild("grid") grid: LigneParametrageFamilleFacturationDataGridComponent;

  private virtualIndex: number = 0;

  public ligneParametrageFamilleFactuList: LigneParametrageFacturation[] = [];

  public gridChanges: LigneParametrageFacturationChanges = new LigneParametrageFacturationChanges();

  // endregion

  // region Propriétés popup de modification de masse

  public isModificationPopupDisplayed: Boolean = false;

  public isPeriodePrixPopupDisplayed: Boolean = false;

  public elementFacturableList: ElementFacturableDTO[] = [];
  public taxeList: TaxeDTO[] = [];
  public familleFacturationList: FamilleFacturationDto[] = [];

  public selectedElementFacturable: any;
  public selectedTaxe: any;
  public selectedPrix: any;
  public selectedTaux: any;
  public dateSelected: Date = new Date();
  public selectedFamilleFacturation: any;

  //endregion

  // region Propriétés popup de modification avant ajout

  @ViewChild("gridPopup") gridPopup: LigneParametrageFamilleFacturationDataGridComponent;

  public isEditLinesPopupDisplayed = false;

  public ligneToAddList: LigneParametrageFacturation[] = [];

  private gridEditChanges: LigneParametrageFacturationChanges = new LigneParametrageFacturationChanges();

  // endregion


  constructor(private facturationClientSvc: FacturationClientService,
              private graphQlSvc: GraphQLService,
              private utilsSvc: UtilsService,
              private toastSvc: ToastService,
              private familleFacturationSvc: FamilleFacturationService) {
  }

  ngOnInit(): void {
    this.initData();
    this.initElementFacturable();
    this.initTaxe();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subData);
    this.utilsSvc.unsubscribe(this.subElementFacturable);
    this.utilsSvc.unsubscribe(this.subTaxe);
    this.utilsSvc.unsubscribe(this.subSave);
    this.utilsSvc.unsubscribe(this.subToAdd);
    this.utilsSvc.unsubscribe(this.subFamillesFacturation);
  }

  private initData(): void {
    this.loadData();
    this.initFamilleFacturation();
  }

  public retrieveNewLigneParametrage(newLignesParametrage: LigneParametrageFacturation[]) {
    this.ligneToAddList = newLignesParametrage;
    this.isEditLinesPopupDisplayed = true;
  }

  public loadData(typePeriode: TypePeriodeFacturationEnum[] = []) {
    const filter = new LigneParametrageFactureClientFilterDto(typePeriode, TypeFactureClientEnum.FACTURE_CLIENT_FAMILLE_FACTURATION);
    this.subData = this.facturationClientSvc.findAllLignesParametrage(filter).subscribe(result => {
      if (result)
        this.ligneParametrageFamilleFactuList = result;
    });
  }

  initFamilleFacturation() {
    this.subFamillesFacturation = this.familleFacturationSvc.findAllFamillesFacturation().subscribe(response => {
      this.familleFacturationList = response.allFamilleFacturation;
    });
  }

  private initElementFacturable() {
    this.subElementFacturable = this.graphQlSvc.sendQuery(`
        {
            allElementsFacturables {
                id,
                libelle,
                taxe {
                    id
                }
            }
        }`
    ).subscribe(result => {
      if (result)
        this.elementFacturableList = result.allElementsFacturables;
    });
  }

  private initTaxe() {
    this.subTaxe = this.graphQlSvc.sendQuery(`
        {
            allTaxes {
                id,
                libelle,
                valeur
            }
        }`
    ).subscribe(result => {
      if (result)
        this.taxeList = result.allTaxes;
    });
  }

  expandAddArea() {
    this.facturationClientSvc.announceOpenAddingAreaLigneParametrage();
  }


  openModificationPopup() {
    this.selectedFamilleFacturation = null;
    this.selectedElementFacturable = null;
    this.selectedTaxe = null;

    this.isModificationPopupDisplayed = true;
  }

  openPeriodePrixPopup() {
    this.selectedPrix = null;
    this.selectedTaux = null;
    this.isPeriodePrixPopupDisplayed = true;
  }

  save() {
    this.subSave = this.facturationClientSvc.saveLignesParametrage(this.gridChanges).subscribe(result => {
      this.gridChanges.clear();
      this.loadData();
    });
  }

  saveEditedLines() {
    this.subSave = this.facturationClientSvc.saveLignesParametrage(this.gridEditChanges).subscribe(result => {
      this.gridEditChanges.clear();
      this.ligneToAddList = [];
      this.mergeLines(result.resultList);
      this.closeEditLinesPopup();
    })
  }

  private mergeLines(lines: LigneParametrageFacturation[]) {
    lines.forEach(line => {
      let index = this.ligneParametrageFamilleFactuList.findIndex(i => i.id === line.id);

      if (index >= 0) {
        Object.assign(this.ligneParametrageFamilleFactuList[index], line);
        this.gridChanges.revert(line);
      } else
        this.ligneParametrageFamilleFactuList.push(line);
    });
  }

  delete() {
    let selected = this.grid.getSelectedData();
    selected.forEach(toDelete => {
      this.gridChanges.delete(toDelete);
    });
    this.ligneParametrageFamilleFactuList = this.ligneParametrageFamilleFactuList.filter(item => !selected.includes(item.id));
  }

  applyModifications() {
    if (this.selectedPrix && this.selectedPrix < 0) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, "Le prix doit être supérieur à 0")
      return;
    }

    let selectedLines = this.isEditLinesPopupDisplayed ? this.gridPopup.getSelectedData() : this.grid.getSelectedData();
    let lignes = this.isEditLinesPopupDisplayed ? this.ligneToAddList : this.ligneParametrageFamilleFactuList;
    let changes = this.isEditLinesPopupDisplayed ? this.gridEditChanges : this.gridChanges;

    let elementFacturable = undefined;
    let taxe = undefined;
    let familleFacturation = undefined;

    if (this.selectedElementFacturable)
      elementFacturable = this.elementFacturableList.find(element => element.id === this.selectedElementFacturable);

    if (this.selectedTaxe)
      taxe = this.taxeList.find(taxe => taxe.id === this.selectedTaxe);

    if (this.selectedFamilleFacturation)
      familleFacturation = this.familleFacturationList.find(ff => ff.id === this.selectedFamilleFacturation);


    lignes.filter(line => selectedLines.includes(line.id))
      .forEach(line => {
        if (elementFacturable) {
          line.elementFacturableId = elementFacturable.id;
          line.elementFacturableLibelle = elementFacturable.libelle
        }

        if (taxe) {
          line.taxeEFId = taxe.id;
          line.taxeEFLibelle = taxe.libelle;
        }

        if (familleFacturation) {
          line.familleFacturationId = familleFacturation.id;
          line.familleFacturationLibelle = familleFacturation.libelle;
        }

        changes.apply(line);
      });

    this.closeModificationPopup();
  }

  applyPeriodePrix() {
    let selectedLines = this.isEditLinesPopupDisplayed ? this.gridPopup.getSelectedData() : this.grid.getSelectedData();
    let lignes = this.isEditLinesPopupDisplayed ? this.ligneToAddList : this.ligneParametrageFamilleFactuList;
    let changes = this.isEditLinesPopupDisplayed ? this.gridEditChanges : this.gridChanges;

    lignes.filter(line => selectedLines.includes(line.id))
      .forEach(line => {
        const updatedList = applyTauxOrPrixToPeriodeList(line.periodeParametrageFacturationList, this.dateSelected, this.selectedPrix, this.selectedTaux);
        if (!updatedList) {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, "Aucun prix de vente défini pour appliquer un taux de revalorisation");
          return;
        }
        line.periodeParametrageFacturationList = updatedList;
        changes.apply(line);
      });

    this.closePeriodePrixPopup();
  }

  closeModificationPopup() {
    this.isModificationPopupDisplayed = false;
  }

  closePeriodePrixPopup() {
    this.isPeriodePrixPopupDisplayed = false;
  }

  updateElementFacturable(data: any) {
    this.selectedElementFacturable = data;
    this.selectedTaxe = this.elementFacturableList.filter(elem => elem.id === data)[0].taxe.id;
  }

  updateFamilleFacturation(data: any) {
    this.selectedFamilleFacturation = data;
  }

  updateTaxe(data: any) {
    this.selectedTaxe = data;
  }

  closeEditLinesPopup() {
    this.isEditLinesPopupDisplayed = false;
    this.gridEditChanges = new LigneParametrageFacturationChanges();
    this.ligneToAddList = [];
  }

  isRowSelected() {
    return this.grid?.getSelectedData().length > 0;
  }

  isPopupRowSelected() {
    return this.gridPopup?.getSelectedData().length > 0;
  }

  canAddValues() {
    return this.ligneToAddList.filter(ligne => ligne.elementFacturableId > 0 && ligne.taxeEFId > 0 && ligne.periodeParametrageFacturationList.length > 0).length == this.ligneToAddList.length;
  }

  getTaxeDisplayValue(taxe: TaxeDTO) {
    return `${taxe.libelle} - ${taxe.valeur}%`
  }

  onChangeDate(date: Date) {
    this.dateSelected = date;
  }
}
